import React from "react";
import "./style.scss";
import { formatMessage } from "devextreme/localization";

export default function Health({ employee = {} }) {
  return (
    <div>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("BloodTypeName")}</div>
            <div className="form-value">
              <span>{employee?.BloodTypeName}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("Height")}</div>
            <div className="form-value">
              <span>{employee?.Height}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("Weight")}</div>
            <div className="form-value">
              <span>{employee?.Weight}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
